const newGetTargetElements = () => {
        const url = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        let rootSelector = `
            form[action="${url}cart"]:not(#cart.cart.form.cart--with-items.gap-theme.heading--text-start),
            .mini-cart-content,tt-desctop-parent-cart > .tt-dropdown-menu, form[action*="/cart"]#updateform,
            cart-drawer.drawer.drawer--cart > .drawer__content > .drawer__header,
            #cart.cart.form.cart--with-items.gap-theme.heading--text-start > .cart__summary,
            .tt-dropdown-menu > .tt-dropdown-inner .tt-cart-box .tt-cart-list,
            form[action*="/cart?locale"]#CartDrawer-Form, form[action*="/cart?locale"]#cart,
            form[action*="${url}cart"]:not([action*="/cart/add"])
        `;
        const themeName = window?.Shopify?.theme?.schema_name;
        if(themeName.includes("Release")){
            if(window.location.pathname !== "/cart"){
                rootSelector = 'cart-drawer-items'; 
            }
        }

        const placementEle = document.querySelectorAll(".salepify-ymal-placement, .salepify-ymal-block")
        return placementEle.length ? placementEle : document.querySelectorAll(rootSelector);
    }
    Object.defineProperty(window, "tlYMAL", {
    set(value) {
      if (value) {
        value.getTargetElements = newGetTargetElements;
      }
      Object.defineProperty(window, "tlYMAL", {
        value,
        writable: true,
        configurable: true
      });
    },
    configurable: true
  });